<template>
  <div class="wrapper">
    <div class="content-wrapper">
      <section class="content p-3">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body text-center">
                  <img
                    :src="logoUrl"
                    alt="Logo de la organización"
                    style="width: 170px"
                  />
                  <h2 class="text-bold">Bienvenido</h2>
                  <h5>
                    {{ $store.getters.getUser.name }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="row hemolife-stats-row justify-content-center">
            <div
              v-for="(ped, index) in pedidos"
              :key="ped.id"
              :class="[
                'col-12',
                'col-sm-6',
                'col-lg-3',
                'hemolife-stat-col',
                { 'mx-auto': pedidos.length === 5 && index === 4 },
              ]"
            >
              <div
                class="small-box hemolife-small-box"
                :class="
                  ped.estado == 1
                    ? 'hemolife-stat--1'
                    : ped.estado == 2
                    ? 'hemolife-stat--2'
                    : ped.estado == 3
                    ? 'hemolife-stat--3'
                    : ped.estado == 4
                    ? 'hemolife-stat--4'
                    : ped.estado == 5
                    ? 'hemolife-stat--5'
                    : 'hemolife-stat--default'
                "
              >
                <div class="inner">
                  <h3>{{ ped.cantidad }}</h3>
                  <p>{{ ped.nEstado }}</p>
                </div>
                <div class="icon">
                  <i
                    class="ion"
                    :class="
                      ped.estado == 1
                        ? 'ion-arrow-graph-down-left'
                        : ped.estado == 2
                        ? 'ion-pie-graph'
                        : ped.estado == 3
                        ? 'ion-stats-bars'
                        : ped.estado == 4
                        ? 'ion-ios-analytics'
                        : ped.estado == 5
                        ? 'ion-arrow-graph-down-left'
                        : 'ion-ios-timer'
                    "
                  ></i>
                </div>
              </div>
            </div>
            <!-- ./col -->
          </div>
          <div
            class="row"
            v-if="$store.getters.can('despachos.tarifas.verTablaTarifas')"
          >
            <div class="form-group col-md-4">
              <label>Rango Fechas</label>
              <div class="row">
                <div class="col-md-6">
                  <input
                    v-model="filtros.fecha_ini"
                    type="date"
                    class="form-control form-control-sm"
                    @change="getDatosTarifas(1)"
                  />
                </div>
                <div class="col-md-6">
                  <input
                    v-model="filtros.fecha_fin"
                    type="date"
                    class="form-control form-control-sm"
                    @change="getDatosTarifas(1)"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="card">
                <div class="card-body table-responsive p-0">
                  <table
                    class="table table-hover table-striped table-bordered text-center"
                  >
                    <thead class="bg-navy text-white">
                      <tr>
                        <th rowspan="2">Pedido</th>
                        <th rowspan="2">Cliente</th>
                        <th rowspan="2">Sede</th>
                        <th rowspan="2">Ciudad</th>
                        <th colspan="3" align="center">Detalle Pedido</th>
                        <th rowspan="2">Fecha Pedido</th>
                        <th rowspan="2">Total</th>
                      </tr>
                      <tr>
                        <th>Componente</th>
                        <th>Cantidad</th>
                        <th>Valor</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="data in tarifasCliente.data" :key="data.id">
                        <td>
                          {{ data.id }}
                        </td>
                        <td>
                          {{ data.cliente.razon_social }}
                        </td>
                        <td>
                          {{ data.sede.nombre }}
                        </td>
                        <td>
                          {{ data.ciudad.nombre }}
                        </td>
                        <td>
                          <div v-for="det in data.det_pedidos" :key="det.id">
                            {{ det.componente.descripcion }}
                          </div>
                        </td>
                        <td>
                          <div v-for="det in data.det_pedidos" :key="det.id">
                            {{ det.cantidad }}
                          </div>
                        </td>
                        <td>
                          <div v-for="det in data.det_pedidos" :key="det.id">
                            {{
                              (det.det_tarifa
                                ? parseFloat(
                                    det.det_tarifa.hist_det_tarifas[0].valor
                                  ) * det.cantidad
                                : "Sin Asignar Tarifa") | formatCurrency
                            }}
                          </div>
                        </td>
                        <td>{{ data.created_at | formatDate }}</td>
                        <td class="text-bold">
                          <span class="badge badge-success">
                            {{
                              calcularTotalTarifas(data.det_pedidos)
                                | formatCurrency
                            }}
                          </span>
                        </td>
                      </tr>
                    </tbody>

                    <!--   <tbody>
                      <tr v-for="data in tarifasCliente.data" :key="data.id">
                        <template v-for="(detalle, index) in data.det_pedidos">
                          <tr :key="detalle.id + '-' + index">
                            
                            <template v-if="index === 0">
                              <td :rowspan="data.det_pedidos.length">
                                {{ data.id }}
                              </td>
                              <td :rowspan="data.det_pedidos.length">
                                {{ data.cliente.razon_social }}
                              </td>
                              <td :rowspan="data.det_pedidos.length">
                                {{ data.sede.nombre }}
                              </td>
                              <td :rowspan="data.det_pedidos.length">
                                {{ data.ciudad.nombre }}
                              </td>
                            </template>
                            <td>{{ detalle.componente.descripcion }}</td>
                            <td>{{ detalle.cantidad }}</td>
                            <td>
                              {{ detalle.det_tarifa.hist_det_tarifas[0].valor }}
                            </td>
                            
                            <template v-if="index === 0">
                              <td :rowspan="data.det_pedidos.length">
                                {{ data.total }}
                              </td>
                            </template>
                          </tr>
                        </template>
                      </tr>
                    </tbody> -->
                  </table>
                </div>
                <div class="card-footer">
                  <div class="float-left" v-if="tarifasCliente.total">
                    Mostrando del <b>{{ tarifasCliente.from }}</b> al
                    <b>{{ tarifasCliente.to }}</b> de un total:
                    <b>{{ tarifasCliente.total }}</b> Registros
                  </div>
                  <div class="float-left" v-else>
                    <span class="badge badge-danger">
                      No hay registros para mostrar
                    </span>
                  </div>
                  <pagination
                    :data="tarifasCliente"
                    @pagination-change-page="getDatosTarifas"
                    :limit="10"
                    class="float-right"
                  ></pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <a
      class="pedido bg-hemolife-red"
      @click="createPedido()"
      v-if="$store.getters.can('despachos.pedidos.create')"
      style="cursor: pointer"
    >
      <i class="fas fa-plus pedido-icon"></i
    ></a>
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import clienteLogo from "../services/clienteLogo";

export default {
  name: "HomeView",
  components: {
    pagination,
  },
  data() {
    return {
      cargando: false,
      pedidos: [],
      tarifasCliente: [],
      filtros: {
        fecha_ini: null,
        fecha_fin: null,
      },
    };
  },

  computed: {
    logoUrl() {
      return clienteLogo(this.$store.getters.getUser);
    },
  },

  filters: {
    formatCurrency(value) {
      // Formato para pesos colombianos (COP), por ejemplo
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
      }).format(value);
    },
    formatDate(value) {
      if (!value) return "";
      const date = new Date(value);
      return date.toLocaleDateString("es-ES", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },

  methods: {
    createPedido() {
      return this.$router.push({
        name: "pedido",
        //params: { accion: "Crear", id: 0 },
      });
    },

    calcularTotalTarifas(detalles) {
      let total = 0;
      detalles.forEach((det) => {
        total += det.det_tarifa
          ? parseFloat(det.det_tarifa.hist_det_tarifas[0].valor) * det.cantidad
          : 0;
      });
      return total;
    },

    async getDatosPedidos() {
      this.cargando = true;
      axios.get("/api/despacho/pedidos/getDatosPedido").then((response) => {
        this.pedidos = response.data;
        this.cargando = false;
      });
    },

    async getDatosTarifas(page = 1) {
      this.cargando = true;
      const params = { page };
      if (this.filtros.fecha_ini) {
        params.fecha_ini = this.filtros.fecha_ini;
      }
      if (this.filtros.fecha_fin) {
        params.fecha_fin = this.filtros.fecha_fin;
      }
      axios
        .get("/api/despacho/pedidos/getTarifasCliente", { params })
        .then((response) => {
          this.tarifasCliente = response.data;
          this.cargando = false;
        });
    },
  },
  async mounted() {
    await this.getDatosTarifas();
    await this.getDatosPedidos();
  },
};
</script>
<style>
.pedido {
  position: fixed;
  width: 50px;
  height: 50px;
  bottom: 8%;
  right: 40px;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  z-index: 100;
  color: #fff;
}

.pedido-icon {
  margin-top: 10px;
}

/* Tarjetas de estado del inicio */
.hemolife-stats-row {
  margin-bottom: 0.25rem;
}

.hemolife-stat-col {
  margin-bottom: 1rem;
}

.hemolife-small-box {
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  overflow: hidden;
  opacity: 1 !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.hemolife-small-box:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.16);
}

.hemolife-small-box .inner {
  padding: 14px 16px 12px;
}

.hemolife-small-box .inner h3 {
  font-weight: 700;
  letter-spacing: -0.02em;
}

.hemolife-small-box .inner p {
  font-size: 0.88rem;
  opacity: 0.95;
  margin-top: 0.35rem;
}

.hemolife-small-box .icon {
  opacity: 0.48;
}

/* Texto claro sobre fondos oscuros suaves */
.hemolife-small-box.hemolife-stat--1 .icon > i,
.hemolife-small-box.hemolife-stat--2 .icon > i,
.hemolife-small-box.hemolife-stat--3 .icon > i {
  color: rgba(255, 255, 255, 0.9);
}

/* Punto medio: más vivos que la versión “apagada”, sin llegar al neón de Bootstrap */
.hemolife-small-box.hemolife-stat--1 {
  background: linear-gradient(145deg, #e06868 0%, #c43d45 100%) !important;
  color: #fff;
}

.hemolife-small-box.hemolife-stat--1 .inner h3,
.hemolife-small-box.hemolife-stat--1 .inner p {
  color: rgba(255, 255, 255, 0.98);
}

.hemolife-small-box.hemolife-stat--2 {
  background: linear-gradient(145deg, #4ab8c2 0%, #2a9aaa 100%) !important;
  color: #fff;
}

.hemolife-small-box.hemolife-stat--2 .inner h3,
.hemolife-small-box.hemolife-stat--2 .inner p {
  color: rgba(255, 255, 255, 0.98);
}

.hemolife-small-box.hemolife-stat--3 {
  background: linear-gradient(145deg, #5c9ae8 0%, #3d7dd4 100%) !important;
  color: #fff;
}

.hemolife-small-box.hemolife-stat--3 .inner h3,
.hemolife-small-box.hemolife-stat--3 .inner p {
  color: rgba(255, 255, 255, 0.98);
}

/* Claros: ámbar y melocotón con más chispa, texto oscuro */
.hemolife-small-box.hemolife-stat--4 {
  background: linear-gradient(145deg, #f5e2a8 0%, #e8c85a 100%) !important;
  color: #2c2618;
}

.hemolife-small-box.hemolife-stat--4 .inner h3,
.hemolife-small-box.hemolife-stat--4 .inner p {
  color: #2c2618;
}

.hemolife-small-box.hemolife-stat--4 .icon > i {
  color: rgba(44, 38, 24, 0.42);
}

.hemolife-small-box.hemolife-stat--5 {
  background: linear-gradient(145deg, #f4b078 0%, #e87838 100%) !important;
  color: #2d1f14;
}

.hemolife-small-box.hemolife-stat--5 .inner h3,
.hemolife-small-box.hemolife-stat--5 .inner p {
  color: #2d1f14;
}

.hemolife-small-box.hemolife-stat--5 .icon > i {
  color: rgba(45, 31, 20, 0.42);
}

.hemolife-small-box.hemolife-stat--default {
  background: linear-gradient(145deg, #8aa4d4 0%, #647ec8 100%) !important;
  color: #fff;
}

.hemolife-small-box.hemolife-stat--default .inner h3,
.hemolife-small-box.hemolife-stat--default .inner p {
  color: rgba(255, 255, 255, 0.98);
}

.hemolife-small-box.hemolife-stat--default .icon > i {
  color: rgba(255, 255, 255, 0.9);
}
</style>

